(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
  });

  initProductAccordion();
  initZoomImage();
})();

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
      const colorGroups = ["ColorA", "ColorB", "ColorC"];

      colorGroups.forEach((color, index) => {
          const radios = document.querySelectorAll(`input[name="properties[${color}]"]`);
          console.log(`Checking: ${color}`, radios); // デバッグ用

          if (radios.length === 0) {
              console.error(`ラジオボタンが見つかりません: properties[${color}]`);
              return;
          }

          const line = document.querySelector(`.order-engineer-3__line.-line${index + 1}`);
          if (!line) {
              console.error(`ラインが見つかりません: .order-engineer-3__line.-line${index + 1}`);
              return;
          }

          radios.forEach(radio => {
              radio.addEventListener("change", function () {
                  const watchSpan = this.closest(".spb-productoptionswatchwrapper").querySelector(".spb-productoptionswatch");

                  if (!watchSpan) {
                      console.error("spb-productoptionswatch が見つかりません");
                      return;
                  }

                  const bgColor = watchSpan.style.background.toLowerCase(); // 小文字に統一
                  console.log(`Updating background for ${color}:`, bgColor);

                  // 背景色を適用
                  line.style.backgroundColor = bgColor;

                  // 背景が白なら文字を黒、それ以外は白
                  if (bgColor === "#ffffff" || bgColor === "rgb(255, 255, 255)" || bgColor === "#fff") {
                      line.style.color = "#000";
                  } else {
                      line.style.color = "#fff";
                  }
              });
          });
      });
  }, 2000); // infinit Optionsが表示されるまで少し時間がかかるため、2秒後に実行
});

